import { all, call, put, select, fork, take, race } from "redux-saga/effects";
import {
  UPLOAD_TO_S3_FAIL,
  INITIALIZE_ATTACHMENTS,
  UPLOAD_TO_S3_SUCCESS,
} from "./attachments/actionTypes";
import { uploadToS3 } from "./attachments/actionCreators";

import { dispatchGeneratorFunc, returnAction } from "./helpers/helpers";
import { messagePostedEvent } from "../../utils/eventTracking";
import { updateBetaIssue } from "./_BETA/issues";

// Selecting an issue
const SELECT = "bonfire/issues/SELECT";
const SELECT_SUCCESS = "bonfire/issues/SELECT_SUCCESS";
const SELECT_FAIL = "bonfire/issues/SELECT_FAIL";

// Adding a comment
export const ADD_COMMENT_REQUEST = "bonfire/issues/ADD_COMMENT_REQUEST";
const COMMENT = "bonfire/issues/COMMENT";
export const COMMENT_SUCCESS = "bonfire/issues/COMMENT_SUCCESS";
export const COMMENT_FAIL = "bonfire/issues/COMMENT_FAIL";

export const POSTING_COMMENT_FAIL = "bonfire/issues/POSTING_COMMENT_FAIL";
export const PASTE_ATTACHMENTS_TO_COMMENT =
  "bonfire/issues/PASTE_ATTACHMENTS_TO_COMMENT";

// TODO: The EquipRule flows should factored out into their own reducer once the
// beta issues replaces the original issues views
export const LOAD_EQUIPRULES = "bonfire/issues/LOAD_EQUIPRULES";
export const LOAD_EQUIPRULES_SUCCESS = "bonfire/issues/LOAD_EQUIPRULES_SUCCESS";
export const LOAD_EQUIPRULES_FAIL = "bonfire/issues/LOAD_EQUIPRULES_FAIL";

// loading usernameList
const LOAD_USERNAMELIST = "bonfire/issues/LOAD_USERNAMELIST";
const LOAD_USERNAMELIST_SUCCESS = "bonfire/issues/LOAD_USERNAMELIST_SUCCESS";
const LOAD_USERNAMELIST_FAIL = "bonfire/issues/LOAD_USERNAMELIST_FAIL";

// sending hashtagNotificationEmail

export const SEND_HASHTAGNOTIFICATION =
  "bonfire/issues/SEND_HASHTAGNOTIFICATION";
export const SEND_HASHTAGNOTIFICATION_SUCCESS =
  "bonfire/issues/SEND_HASHTAGNOTIFICATION_SUCCESS";
export const SEND_HASHTAGNOTIFICATION_FAIL =
  "bonfire/issues/SEND_HASHTAGNOTIFICATION_FAIL";

// Update frontend after saving
const UPDATE_ISSUE_CHANGES = "bonfire/issues/UPDATE_ISSUE_CHANGES";
const UPDATE_COMMENT_CHANGES = "bonfire/issues/UPDATE_COMMENT_CHANGES";

export const UPDATE_TAGGING_LIST = "bonfire/issues/UPDATE_TAGGING_LIST";

const initialState = {
  loaded: false,
  commenting: false,
  postingComment: false,
  completingIssue: false,
  editing: {},
  saveError: {},
  selected: { key: undefined },
  data: [],
  sites: {},
  priorities: {},
  contexts: {},
  statuses: {},
  insite_statuses: {},
  projects: {},
  parties: {},
  comments: [],
  issue: {},
  status: [],
  usernameList: [],
  taggingList: [],
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_EQUIPRULES_SUCCESS:
      return {
        ...state,
        issue: { ...state.issue, equipRules: action.result },
        error: null,
      };
    case LOAD_EQUIPRULES_FAIL:
      return {
        ...state,
        issue: { ...state.issue, equipRules: null },
        error: action.error,
      };
    case SELECT:
      return {
        ...state,
        selected: action.selected,
        comments: [],
        attachments: [],
        attachment_to_add: {},
        error: null,
        uploadError: null,
      };
    case SELECT_SUCCESS:
      return {
        ...state,
        selected: action.selected,
        comments: action.result,
        comments_loaded: true,
      };
    case SELECT_FAIL:
      return {
        ...state,
        selected: {},
        comments_loaded: false,
      };
    case COMMENT:
      return {
        ...state,
        commenting: true,
      };
    case COMMENT_SUCCESS: {
      return {
        ...state,
        comments: [...state.comments, action.result],
        commenting: false,
        postingComment: false,
        completingIssue: false,
        error: null,
        uploadError: null,
      };
    }
    case COMMENT_FAIL:
      return {
        ...state,
        commenting: false,
      };
    case POSTING_COMMENT_FAIL:
      return {
        ...state,
        postingComment: false,
      };
    case ADD_COMMENT_REQUEST:
      return {
        ...state,
        comment: action.comment,
        postingComment: action.action === "postComment",
        completingIssue: action.action === "completeIssue",
      };
    case PASTE_ATTACHMENTS_TO_COMMENT: {
      // Paste attachments to comment
      const comment = Object.assign({}, state.comment);
      const imageLinks = action.attachments.map(
        (attachment) => `[${attachment.fileName}|${attachment.imageUrl}]`
      );
      comment.text +=
        imageLinks.length > 0 ? "\n\n----- Attachments -----\n" : "\n";
      comment.text += imageLinks.join("\n");
      return {
        ...state,
        comment,
      };
    }

    case LOAD_USERNAMELIST:
      // load Username List
      return {
        ...state,
        usernameList: [],
      };
    case LOAD_USERNAMELIST_SUCCESS:
      return {
        ...state,
        usernameList: action.result,
      };
    case LOAD_USERNAMELIST_FAIL:
      return {
        ...state,
      };

    case UPDATE_TAGGING_LIST:
      return {
        ...state,
        taggingList: action.taggingList,
      };
    default:
      return state;
  }
}

/*
 * Exported Action Creators
 */
export function isLoaded(globalState) {
  return globalState.issues && globalState.issues.loaded;
}

export const selectRow = (issue, user) => ({
  types: [SELECT, SELECT_SUCCESS, SELECT_FAIL],
  selected: issue,
  promise: (client) =>
    client.get(`/comments/${issue.key}`, {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    }),
});

export const addComment = (comment, user) => ({
  types: [COMMENT, COMMENT_SUCCESS, COMMENT_FAIL],
  promise: (client) =>
    client.post(`v2/actions/${comment.key}/comments`, {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
      data: {
        body: comment.text,
      },
    }),
});

// TODO: This shouldn't live in the store.  It should be attached directly to the active action
export const getUsernameList = (user, selectedProject) => {
  let queryString = "";
  if (selectedProject.components === "") {
    queryString = `/hashtagUsernamelist/${selectedProject.project_key}/NULL`;
  } else {
    queryString = `/hashtagUsernamelist/${selectedProject.project_key}/${selectedProject.components}`;
  }

  return {
    types: [
      LOAD_USERNAMELIST,
      LOAD_USERNAMELIST_SUCCESS,
      LOAD_USERNAMELIST_FAIL,
    ],
    promise: (client) =>
      client.get(queryString, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      }),
  };
};

// TODO: Why is this in the store?
export const sendHashtagNotificationEmail = (
  user,
  hashtagList,
  issue,
  comment
) => ({
  types: [
    SEND_HASHTAGNOTIFICATION,
    SEND_HASHTAGNOTIFICATION_SUCCESS,
    SEND_HASHTAGNOTIFICATION_FAIL,
  ],
  promise: (client) =>
    client.post("/hashtag-notification", {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
      data: {
        hashtagList,
        comment,
        issue,
        user,
        workflow: false,
      },
    }),
});

/**
 * OTHER ACTION CREATORS
 */

// starts a saga; includes uploading of attachments first before posting comment
export const startAddComment = (comment, action) =>
  returnAction(ADD_COMMENT_REQUEST, { comment, action });
export const updateSelectedIssue = (issueKey, params) =>
  returnAction(UPDATE_ISSUE_CHANGES, { issue_key: issueKey, params });
export const updateCommentList = (comment) =>
  returnAction(UPDATE_COMMENT_CHANGES, { comment });
export const updateTaggingList = (taggingList) =>
  returnAction(UPDATE_TAGGING_LIST, { taggingList });
export const actionCreators = {
  selectRow,
  getUsernameList,
  addComment,
  startAddComment,
  updateSelectedIssue,
  updateCommentList,
  sendHashtagNotificationEmail,
  updateTaggingList,
};

/**
 * SAGA WATCHERS
 */

export const getAuthUser = (state) => state.auth.user;

// #hashtag

export const getTaggingList = (state) => state.issues.taggingList;

// Selectors
export const getAttachments = (state) => state.attachments.attachments;
export const getComment = (state) => state.issues.comment;

export function* appendAttachmentsToComment(attachments) {
  yield put({ type: PASTE_ATTACHMENTS_TO_COMMENT, attachments });
}

export function* dispatchPostCommentFailAction() {
  yield put({ type: POSTING_COMMENT_FAIL });
}

function commentPostSucceededAndAtLeastOneUserIsTagged(
  commentResult,
  taggingList
) {
  return commentResult.type === COMMENT_SUCCESS && taggingList.length > 0;
}

export function* postComment(issue, comment, user, taggingList) {
  yield fork(dispatchGeneratorFunc, addComment, comment, user);

  const commentResult = yield take([COMMENT_FAIL, COMMENT_SUCCESS]);

  if (commentResult.type === COMMENT_SUCCESS) {
    messagePostedEvent(issue, commentResult);
    // HACK: Update updated time in relevant action so that it's
    // reflected in the list in real time.
    yield put(updateBetaIssue(issue.key, commentResult.result.updated));
  }

  if (
    commentPostSucceededAndAtLeastOneUserIsTagged(commentResult, taggingList)
  ) {
    yield fork(
      dispatchGeneratorFunc,
      sendHashtagNotificationEmail,
      user,
      taggingList,
      issue,
      comment
    );
    // NOTE: We're not actually handling this failure...
    yield take([
      SEND_HASHTAGNOTIFICATION_SUCCESS,
      SEND_HASHTAGNOTIFICATION_FAIL,
    ]);
    // TODO: Should dispatch an action that handles a failure to send notification
    // put({ type: HANDLE_ME_PLEASE!!! })
  }
}

export function* uploadAttachments(attachments) {
  yield all(
    attachments.map((attachment) =>
      fork(
        dispatchGeneratorFunc,
        uploadToS3,
        attachment.uploadUrl,
        attachment.file
      )
    )
  );
}

export const getSelectedIssue = (state) => state.betaAction.action;
/*
 * Handles posting of Comments but upload attachments first (if there is)
 * Note that upload is done directly from bonfire to s3.
 * If one of the upload fails, returns an error and posting of comment will not pursue.
 */
export function* postCommentFlow() {
  while (true) {
    yield take(ADD_COMMENT_REQUEST);

    const attachments = yield select(getAttachments) || [];

    // NOTE: This will retrieve the currently active action from the betaAction store.
    // This file should eventually go away, and all issue/action responsibility will live
    // in the /action store
    // TODO: Temporary - Comment flow should live in an entirely different store.
    const issue = yield select(getSelectedIssue);

    const taggingList = yield select(getTaggingList);
    const user = yield select(getAuthUser);
    let comment = yield select(getComment);

    // If attachments present, handle upload and append to comment...
    if (attachments.length > 0) {
      yield call(uploadAttachments, attachments);
      // NOTE: This really only checks for one success or fail.
      // TODO: Update flow to account for entire array of attachments.
      // See `for/of` pattern for doing this.
      const { success, fail } = yield race({
        success: take(UPLOAD_TO_S3_SUCCESS),
        fail: take(UPLOAD_TO_S3_FAIL),
      });
      if (fail) {
        yield call(dispatchPostCommentFailAction);
      } else if (success) {
        yield call(appendAttachmentsToComment, attachments);

        // NOTE: comment (in our store) is modified by appendAttachmentsToComment so we
        // have to retrieve the updated comment
        comment = yield select(getComment);

        // Reset attachments state
        yield put({ type: INITIALIZE_ATTACHMENTS });
      }
    }

    // ...otherwise just post the comment
    yield call(postComment, issue, comment, user, taggingList);
  }
}

export default reducer;
